import React, {FC, Fragment} from 'react';
import messages from '../messages';
import {useMaterialDeleteForm} from './use-material-delete-form';
import Button from 'components/button';
import {useTranslation} from 'react-i18next';
import {ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap';
import {ObjectId} from 'types/object-id';

interface Props {
  message?: string;
  onDismiss: () => void;
  materialId: ObjectId;
}

const MaterialArchiveModal: FC<Props> = props => {
  const {onDismiss, materialId} = props;
  const {validationErrors, isLoading, errorMessage, submit} =
    useMaterialDeleteForm(onDismiss, materialId);
  const {t} = useTranslation();

  return (
    <Fragment>
      <ModalHeader className="bg-primary" toggle={onDismiss}>
        <span className="text-light">{t(...messages.actionOnMaterials())}</span>
      </ModalHeader>
      <ModalBody className="">
        <div>
          <Row>{t(...messages.deleteAlertMessage())}</Row>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="important" onClick={submit} isLoading={isLoading}>
          {t(...messages.yesImSure())}
        </Button>
        <Button color="secondary" onClick={onDismiss}>
          {t(...messages.cancel())}
        </Button>
      </ModalFooter>
    </Fragment>
  );
};

export default MaterialArchiveModal;
